import {BASE_URL, DEMAND, GET, PAGE_SIZE, POST,} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";
  
export const demandAction = async (payload,id) => {
const token = await getAccessToken();
const resource = `${BASE_URL}${DEMAND}/${id}/action`;
return fetch(resource, {
    method: POST,
    headers: {
    "Content-Type": "application/json",
    "userauth": `Bearer ${token}`
    },
    body: JSON.stringify(payload)
})
    .then(statusParsing)
    .then(jsonParsing);
};


export const fetchDemandComments = async (requestId,next,pageSize=PAGE_SIZE) => {
  const token = await getAccessToken();    
  let url = `${BASE_URL}${DEMAND}/${requestId}/${"comments"}`;   
  if(next){
    url=`${url}?next=${next}`
  }
  if(pageSize){
    url=`${url}?pageSize=${pageSize}`
  }
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};

  export const fetchActivityLog = async(id) => {
    const token = await getAccessToken();  
    let url = `${BASE_URL}${DEMAND}/${id}/${"activity-logs"}`;

    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userAuth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing); 
  };